
import dateFormat from 'vux/src/tools/date/format.js'

export default {
  name: 'count-down',
  data() {
    return {
      countDown: '',
      show: true
    }
  },
  computed: {
    live() {
      return this.$store.state.live.detail
    }
  },
  methods: {
    time() {
      var date1 = this.live.BeginAt //开始时间
      var date2 = dateFormat(new Date(), 'YYYY-MM-DDTHH:mm:ss') //现在
      // console.log(date2)
      var date3 = new Date(date1).getTime() - new Date(date2).getTime() //时间差的毫秒数

      if (date3 <= 0) {
        // 清除计时器，隐藏控件
        window.clearInterval(this.time)
        this.show = false
        return false
      }
      //计算出相差天数
      var days = Math.floor(date3 / (24 * 3600 * 1000))
      //计算出小时数
      var leave1 = date3 % (24 * 3600 * 1000) //计算天数后剩余的毫秒数
      var hours = Math.floor(leave1 / (3600 * 1000))
      //计算相差分钟数
      var leave2 = leave1 % (3600 * 1000) //计算小时数后剩余的毫秒数
      var minutes = Math.floor(leave2 / (60 * 1000))
      //计算相差秒数
      var leave3 = leave2 % (60 * 1000) //计算分钟数后剩余的毫秒数
      var seconds = Math.round(leave3 / 1000)
      this.countDown = `${days}天${hours}小时${minutes}分钟${seconds}秒`
    }
  },
  mounted() {
    setInterval(this.time, 1000)
  },
  components: {}
}



// WEBPACK FOOTER //
// ./src/components/CountDown/CountDown.vue